<template>
  <div
    class="
      h-screen
      flex
      w-full
      bg-login
      vx-row
      no-gutter
      items-center
      justify-center
    "
    id="page-login"
  >
    <div class="vx-col sm:m-0 m-4">
      <vx-card class="p-2">
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col sm:w-full md:w-full d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">
                <img
                  src="@/assets/images/pages/tacna-logo.svg"
                  alt="logo-tacna"
                  class="mx-auto w-4/5"
                />
                <div class="p-1 text-center" :style="{ opacity: '0.8' }">
                  Proveedores
                </div>
                <div class="p-10">
                  <vs-input
                    name="rfc"
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="RFC"
                    v-model="data.rfc"
                    v-on:keyup.enter="getInfo()"
                    class="w-full mt-2"
                    maxlength="13"
                  ></vs-input>

                  <vue-recaptcha
                    class="mt-5"
                    ref="recaptcha"
                    :sitekey="sitekey"
                    @expired="onExpired"
                    @verify="onVerify"
                  ></vue-recaptcha>
                  <div class="flex flex-wrap items-center justify-center my-3">
                    <vs-button
                      ref="loadableButton"
                      id="button-with-loading"
                      class="vs-con-loading__container"
                      :disabled="loadingButton"
                      @click="getInfo()"
                      >Sign In</vs-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
      <div class="vx-row no-gutter justify-center items-center pt-20">
        <p>© 2020 TACNA Services, Inc. All Rights Reserved.</p>
      </div>
    </div>
  </div>
</template>

<script>
import vendor from '@/http/requests/vendor/index.js'
import VueRecaptcha from 'vue-recaptcha'
export default {
  components: { VueRecaptcha },
  data() {
    return {
      info: [],
      sitekey: '6Lcu3cYZAAAAAC1DXgWVkUoQV4TwiEGWj89cAH2Z',
      loadingButton: false,
      data: {
        rfc: '',
        recaptcha: '',
      },
    }
  },
  methods: {
    getInfo() {
      this.$vs.loading()
      vendor
        .vendorCheck(this.data)
        .then((res) => {
          localStorage.setItem('vendor', JSON.stringify(res.data.vendor))
          this.$router.push('/expenses')
          //this.$refs.recaptcha.reset()
          this.$vs.loading.close()
        })
        .catch((err) => {
          if (422 === err.response.status) {
            let errors = err.response.data.errors
            let errorArray = Object.keys(errors).map(function (key) {
              return [key, errors[key]]
            })
            errorArray.forEach((element) => {
              this.$vs.notify({
                color: 'danger',
                title: 'Alert',
                text: element[1][0],
              })
            })
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Alert',
              text: 'SERVER ERROR',
            })
          }
          this.$refs.recaptcha.reset()
          this.$vs.loading.close()
        })
    },
    onVerify: function (response) {
      this.data.recaptcha = response
    },
    onExpired: function () {
      this.$vs.notify({
        color: 'danger',
        title: 'Atención',
        text: 'El captcha a expirado.',
      })
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset() // Direct call reset method
    },
  },
  mounted() {
    if (JSON.parse(localStorage.getItem('vendor')) != null) {
      this.$router.push('/expenses')
    } else {
      localStorage.clear()
    }
  },
}
</script>